module.exports = "<div style=\"z-index:-1\" class=\"maximize frameOverlay\"></div><i ng-if=\"showReportSettingsBtn()\" ng-click=\"openReportsSettings()\" ng-style=\"settingsRight\" title=\"{{::'Настройки отчета' | gettext}}\" class=\"report-settings icon-cog pull-right\"></i>"


//////////////////
// WEBPACK FOOTER
// ./src/view/frame-view.component.html
// module id = 471
// module chunks = 0